class CartItemSubscribe extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const button = event.target.closest('.cart-item__subscribe-btn');
    if (!button) return;
    event.preventDefault();
    this.subscribe(button);
  }

  subscribe(button) {
    const key = this.dataset.line;
    const plan = this.dataset.plan;
    const quantity = parseInt(this.dataset.quantity, 10) || 1;
    if (!key || !plan) return;

    button.setAttribute('disabled', 'disabled');
    button.classList.add('is-loading');

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const body = JSON.stringify({
      id: key,
      quantity,
      selling_plan: Number(plan),
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    })
      .then((response) => response.json())
      .then((state) => {
        if (state.status) {
          button.removeAttribute('disabled');
          button.classList.remove('is-loading');
          return;
        }
        this.renderSections(state);
      })
      .catch(() => {
        button.removeAttribute('disabled');
        button.classList.remove('is-loading');
      });
  }

  renderSections(state) {
    if (!state.sections) return;

    const parser = new DOMParser();
    const getInner = (html, selector) => {
      const node = parser.parseFromString(html, 'text/html').querySelector(selector);
      return node ? node.innerHTML : '';
    };

    if (state.sections['cart-drawer']) {
      const drawerContent = document.querySelector('#CartDrawer');
      if (drawerContent) {
        drawerContent.innerHTML = getInner(state.sections['cart-drawer'], '#CartDrawer');
      }
    }

    if (state.sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        bubble.innerHTML = getInner(state.sections['cart-icon-bubble'], '.shopify-section');
      }
    }

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') {
      overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    drawer.classList.add('active');
    const inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
  }
}

if (!customElements.get('cart-item-subscribe')) {
  customElements.define('cart-item-subscribe', CartItemSubscribe);
}
